/**
 * @flow
 * @relayHash 6203b3795b04ca5b42188eadee24f7c8
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type TitleIssueTable_project$ref = any;
export type onpage_OnPageCategory_TitleIssueTable_QueryVariables = {|
  host: string
|};
export type onpage_OnPageCategory_TitleIssueTable_QueryResponse = {|
  +project: ?{|
    +$fragmentRefs: TitleIssueTable_project$ref
  |}
|};
export type onpage_OnPageCategory_TitleIssueTable_Query = {|
  variables: onpage_OnPageCategory_TitleIssueTable_QueryVariables,
  response: onpage_OnPageCategory_TitleIssueTable_QueryResponse,
|};
*/


/*
query onpage_OnPageCategory_TitleIssueTable_Query(
  $host: String!
) {
  project(host: $host) {
    ...TitleIssueTable_project
    id
  }
}

fragment TitleIssueTable_project on Project {
  host
  crawls(offset: 0, limit: 1) {
    edges {
      node {
        countTypesTitleIssues(title: {operator: AND, values: []}, url: {operator: AND, values: []}) {
          type
          severity
          count
        }
        titleIssues(offset: 0, limit: 20, typeFilters: [], url: {operator: AND, values: []}, lenOrder: 0, title: {operator: AND, values: []}) {
          count
          edges {
            node {
              id
              ...TitleIssueRow_issue
            }
          }
        }
        id
      }
    }
  }
}

fragment TitleIssueRow_issue on TitleIssue {
  id
  severity
  title
  title_len_chr
  title_len_px
  type
  urls
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "host",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "host",
    "variableName": "host",
    "type": "String!"
  }
],
v2 = {
  "kind": "Literal",
  "name": "offset",
  "value": 0,
  "type": "Int"
},
v3 = {
  "operator": "AND",
  "values": ([]/*: any*/)
},
v4 = {
  "kind": "Literal",
  "name": "title",
  "value": v3,
  "type": "TextFilters"
},
v5 = {
  "kind": "Literal",
  "name": "url",
  "value": v3,
  "type": "TextFilters"
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "severity",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "count",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "onpage_OnPageCategory_TitleIssueTable_Query",
  "id": null,
  "text": "query onpage_OnPageCategory_TitleIssueTable_Query(\n  $host: String!\n) {\n  project(host: $host) {\n    ...TitleIssueTable_project\n    id\n  }\n}\n\nfragment TitleIssueTable_project on Project {\n  host\n  crawls(offset: 0, limit: 1) {\n    edges {\n      node {\n        countTypesTitleIssues(title: {operator: AND, values: []}, url: {operator: AND, values: []}) {\n          type\n          severity\n          count\n        }\n        titleIssues(offset: 0, limit: 20, typeFilters: [], url: {operator: AND, values: []}, lenOrder: 0, title: {operator: AND, values: []}) {\n          count\n          edges {\n            node {\n              id\n              ...TitleIssueRow_issue\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment TitleIssueRow_issue on TitleIssue {\n  id\n  severity\n  title\n  title_len_chr\n  title_len_px\n  type\n  urls\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "onpage_OnPageCategory_TitleIssueTable_Query",
    "type": "RootQuery",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "TitleIssueTable_project",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "onpage_OnPageCategory_TitleIssueTable_Query",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "host",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "crawls",
            "storageKey": "crawls(limit:1,offset:0)",
            "args": [
              {
                "kind": "Literal",
                "name": "limit",
                "value": 1,
                "type": "Int"
              },
              v2
            ],
            "concreteType": "CrawlsConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CrawlsEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Crawl",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "countTypesTitleIssues",
                        "storageKey": "countTypesTitleIssues(title:{\"operator\":\"AND\",\"values\":[]},url:{\"operator\":\"AND\",\"values\":[]})",
                        "args": [
                          v4,
                          v5
                        ],
                        "concreteType": "CountType",
                        "plural": true,
                        "selections": [
                          v6,
                          v7,
                          v8
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "titleIssues",
                        "storageKey": "titleIssues(lenOrder:0,limit:20,offset:0,title:{\"operator\":\"AND\",\"values\":[]},typeFilters:[],url:{\"operator\":\"AND\",\"values\":[]})",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "lenOrder",
                            "value": 0,
                            "type": "Int"
                          },
                          {
                            "kind": "Literal",
                            "name": "limit",
                            "value": 20,
                            "type": "Int"
                          },
                          v2,
                          v4,
                          {
                            "kind": "Literal",
                            "name": "typeFilters",
                            "value": [],
                            "type": "[String]"
                          },
                          v5
                        ],
                        "concreteType": "TitleIssuesConnection",
                        "plural": false,
                        "selections": [
                          v8,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "TitleIssuesEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "TitleIssue",
                                "plural": false,
                                "selections": [
                                  v9,
                                  v7,
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "title",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "title_len_chr",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "title_len_px",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  v6,
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "urls",
                                    "args": null,
                                    "storageKey": null
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      v9
                    ]
                  }
                ]
              }
            ]
          },
          v9
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd01b88292f2efb6f7df9c6b6d7a07643';
module.exports = node;
